import { AsyncPipe } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import {
  GcPillComponent,
  GcTableColumn,
  GcTableComponent,
  GcTableRow,
  IpoLanguageService,
  IpoTranslateArrayPipe,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import {
  GcTableWrapperComponent,
  GcTableWrapperConfig,
} from '../../../shared/gc-table-wrapper/gc-table-wrapper.component';
import { LabelValueComponent } from '../../../shared/label-value/label-value.component';
import { SectionStatusStyle } from '../../../shared/status-style/status-style-maps';
import { StatusTableCellComponent } from '../../../shared/status-table-cell/status-table-cell.component';
import { SectionStatus } from '../../entities/installation-reporting-mdu.entities';
import { getDeliveryStatusTag } from '../../helpers/delivery-status.helper';
import {
  getSectionStatusDate,
  getSectionStatusLabelKey,
  getSectionStatusValue,
} from './report-mdu-table-status.helper';

export interface SectionContext {
  section: SectionStatus;
}

const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [5, 10, 15];

@Component({
  selector: 'app-group-agreement-details-table',
  imports: [
    GcTableComponent,
    GcTableWrapperComponent,
    GcPillComponent,
    StatusTableCellComponent,
    IpoTranslateArrayPipe,
    IpoTranslatePipe,
    AsyncPipe,
    LabelValueComponent,
  ],
  templateUrl: './group-agreement-details-table.component.html',
  styleUrl: './group-agreement-details-table.component.scss',
})
export class GroupAgreementDetailsTableComponent {
  private readonly languageService = inject(IpoLanguageService);

  language$ = this.languageService.getLanguage$();

  tableTitle = input<string>();
  tableTitleCount = input<number>();
  tableRows = input<GcTableRow[]>([]);
  tableColumns = input<GcTableColumn[]>([]);
  selectableRows = input<boolean>(true);
  currentItemsPerPage = input<number | null>(null);
  activePage = input<number>(0);
  numberOfPages = input<number>(1);
  searchFilter = input<string>('');

  rowClicked = output<GcTableRow>();
  itemsPerPageSelected = output<number | null>();
  paginationChanged = output<number>();
  searchInputChanged = output<string>();

  tableWrapperConfig = computed<GcTableWrapperConfig>(() =>
    this.configureTableWrapperData(),
  );

  sectionStatusStyles = SectionStatusStyle;

  configureTableWrapperData(): GcTableWrapperConfig {
    return {
      title: this.tableTitle(),
      titleCount: this.tableTitleCount(),
      tableToolbar: {
        pageSizePicker: {
          currentItemsPerPage: this.currentItemsPerPage(),
          allowAll: true,
          itemsPerPageOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
          label: 'tabletoolBar.itemsPerPage',
        },
        searchInput: {
          value: this.searchFilter(),
          placeholder: 'tabletoolBar.searchPlaceholder',
        },
      },
      pagination: {
        activePage: this.activePage(),
        numberOfPages: this.numberOfPages(),
      },
    } as GcTableWrapperConfig;
  }

  onRowClicked(row: GcTableRow): void {
    this.rowClicked.emit(row);
  }

  onPaginationChanged(value: number): void {
    this.paginationChanged.emit(value);
  }

  setItemsPerPage(option: number | null): void {
    this.itemsPerPageSelected.emit(option);
  }

  onSearchInputChanged(searchString: string): void {
    this.searchInputChanged.emit(searchString);
  }

  sectionStatusValue = getSectionStatusValue;

  sectionStatusLabelKey = getSectionStatusLabelKey;

  sectionStatusDate = getSectionStatusDate;

  deliveryStatusTag = getDeliveryStatusTag;
}
